var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 148,
    viewBox: "0 0 352 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M351.58 147.381C351.58 147.381 348.55 123.146 313.208 127.184C313.208 127.184 334.413 73.6642 297.049 69.6234C259.686 65.585 235.45 91.8394 235.45 91.8394C235.45 91.8394 231.412 2.9751 180.92 0.955895C130.427 -1.06331 85.9953 83.7626 85.9953 83.7626C85.9953 83.7626 77.9162 49.4289 54.6917 58.5165C31.4648 67.6041 0.161133 147.381 0.161133 147.381H351.58Z",
    fill: "#6B5E17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBush);
export default __webpack_public_path__ + "static/media/bush.2dd4718a70c349c2edb979414150ecea.svg";
export { ForwardRef as ReactComponent };